<template>
  <v-dialog v-model="dialog" max-width="560" persistent>
    <v-card>

      <!-- Header -->
      <div style="background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%); padding: 16px 20px; display: flex; align-items: center; justify-content: space-between; gap: 12px;">
        <div class="d-flex align-center" style="gap: 12px;">
          <v-avatar color="rgba(255,255,255,0.15)" size="38">
            <v-icon color="white" size="20">mdi-link-variant</v-icon>
          </v-avatar>
          <div>
            <div style="font-size: 1rem; font-weight: 700; color: #fff;">Enlace de registro de contactos:</div>
            <!-- <div style="font-size: 0.75rem; color: rgba(255,255,255,0.65);">{{ programa.nombre_compuesto }}</div> -->
          </div>
        </div>
        <v-btn icon dark small @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pt-4 pb-2 px-5">

        <!-- Info unidad -->
        <!-- <div v-if="unidad && unidad.nombre" class="mb-3">
          <v-row dense>
            <v-col cols="12" sm="6">
              <span class="ge-label">Unidad</span>
              <div class="ge-value">{{ unidad.nombre }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <span class="ge-label">Código</span>
              <div class="ge-value">{{ unidad.codigo }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <span class="ge-label">Correo</span>
              <div class="ge-value">{{ unidad.email }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <span class="ge-label">Sitio web</span>
              <div class="ge-value">{{ unidad.sitio_web }}</div>
            </v-col>
          </v-row>
        </div>

        <v-divider class="mb-3" /> -->

        <!-- Descripción -->
        <p style="font-size: 0.83rem; color: #546e7a;" class="mb-0">
          Comparte este enlace con tus contactos. Es único y te identifica como asesor para quienes
          se registren en:
        </p>
        <p class="mt-0">
          <b> {{ programa.nombre_compuesto }} </b>
        </p>

        <v-progress-linear indeterminate height="2" color="indigo lighten-3" class="mb-3" v-if="loading_negocio" />

        <template v-if="unidad.sitio_web">

          <!-- QR -->
          <div class="d-flex justify-center mb-3">
            <div id="aquivaelqr" ref="aquivaelqr"></div>
          </div>

          <!-- Enlace principal -->
          <div class="ge-link-box mb-2">
            
            <textarea
              rows="4"
              ref="inputenlace"
              v-model="enlace"
              readonly
              class="ge-link-input"
            />

            <p v-if="unidad.id == 15">Para programas de upi bolivia con todas las instituciones:</p>
            <textarea
              v-if="unidad.id == 15"
              rows="4"
              ref="inputenlace"
              v-model="enlace2"
              readonly
              class="ge-link-input"
            /> 
          </div>
          <!-- <small class="grey--text">
            <b> Enlace corto, aun no esta en uso, pero puedes probarlo antes de compartirlo con tus contactos: </b>
            {{ enlace_corto }}
          </small> -->

          <v-alert v-if="copiado" type="success" dense text class="mt-2 mb-0" style="font-size:0.8rem;">
            Enlace copiado al portapapeles.
          </v-alert>

        </template>

        <v-alert v-else-if="!loading_negocio" type="error" dense outlined style="font-size:0.82rem;">
          No se pudo generar el enlace: la unidad <strong>{{ unidad.nombre }}</strong> no tiene sitio web asignado.
        </v-alert>

      </v-card-text>

      <v-card-actions class="px-5 pb-8">
        <v-spacer />
        <v-btn text @click="cerrar">Cerrar</v-btn>
        <v-btn depressed color="indigo darken-1" dark
          :disabled="loading_negocio || !unidad.sitio_web"
          @click="copytext">
          <v-icon left small>mdi-clipboard-check-outline</v-icon> Copiar enlace
        </v-btn>
        <v-btn depressed color="teal darken-1" dark
          :disabled="loading_negocio || !unidad.sitio_web"
          @click="descargarqr">
          <v-icon left small>mdi-qrcode</v-icon> Descargar QR
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import xaxios from '@/xaxios';

export default {
  props: { obj: { type: Object, required: false } },
  data() {
    return {
      dialog: false,
      activo: true,
      copiado: false,
      programa: {},
      token: '',
      enlace: '',
      enlace2: '',
      enlace_corto: '',
      loading_negocio: false,
      unidad: {},
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.copiado = false;
        this.activo = true;
      }
    },
  },
  methods: {
    cerrar() {
      this.dialog = false;
    },
    async copytext() {
      await navigator.clipboard.writeText(this.enlace);
      let input = this.$refs['inputenlace'];
      input.select();
      input.setSelectionRange(0, 99999);
      document.execCommand('copy');
      this.copiado = true;
    },
    open(programa) { 
      if (programa.fase == 0) {
        this.$root.$notify.show('El programa no esta aprobado.', { color: 'red', x: 'right' });
        return;
      }
      this.enlace = '';
      this.enlace2 = '';
      this.enlace_corto = '';
      this.programa = programa;
      this.dialog = true;
      this.getunidadnegocio();
    },
    async getunidadnegocio() {
      this.loading_negocio = true;
      let unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
      if (this.programa.unidad_negocio) {
        unidad_negocio = this.programa.unidad_negocio;
      }
      const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/unidadnegocio`;
      let res = await xaxios.get(url).then(({ data }) => data).catch((e) => e);
      this.unidad = res.find((x) => x.id == unidad_negocio);
      if (!this.unidad.sitio_web) this.unidad.sitio_web = 'https://esam.edu.bo';
      this.generate_link_form()
      this.loading_negocio = false;
      this.$nextTick(() => { this.crearqrenlace(); });
    }, 
    crearqrenlace() {
      let imglogo = 'img/logo_esam_factura.png';
      if (this.unidad.id == 10) imglogo = 'img/dbslogob.png';
      var options = {
        text: this.enlace,
        width: 720,
        height: 720,
        logo: imglogo,
        logoBackgroundTransparent: true,
        quietZone: 4,
        version: 0,
        dotScale: 1,
        correctLevel: window.QRCode.CorrectLevel.Q,
        onRenderingEnd: this.renderingEnd(),
      };
      var element = document.getElementById('aquivaelqr');
      element.innerHTML = '';
      new window.QRCode(element, options);
      window.$('canvas', '#aquivaelqr').css('width', '150px');
    },
    descargarqr() {
      let p = this.programa.nombre_compuesto;
      let a = this.$store.state.DATA_USER.nombres;
      var save = document.createElement('a');
      let div = document.getElementById('aquivaelqr');
      var canvas = div.querySelector('canvas');
      var image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
      save.href = image;
      save.target = '_blank';
      save.download = 'QR-' + a + '-' + p + '.jpg';
      save.click();
    },
    codificarBase64(texto) {
      return btoa(texto);
    },
    renderingEnd() {},
    submit() {},

    generate_link_form(){
      const u = this.$store.state.DATA_USER;       
      if(!u.seg_apellido) u.seg_apellido =''
      
      // let a = 2
      // if(a > 1){
      let unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
      if (this.programa.unidad_negocio) {
        unidad_negocio = this.programa.unidad_negocio;
      }
      const convenio = this.programa.universidad?.id;
      // window.console.log('convenio',convenio);
      
      const unidades = [1,5,10]
      if( unidades.includes(unidad_negocio) && (convenio == 9 || convenio == 20) ){
        this.generartoken_new_formu()
      }else{
        this.generartoken()
      }
    },

    generartoken_new_formu(){
      const u = this.$store.state.DATA_USER;       
      if(!u.seg_apellido) u.seg_apellido ='';

      const areaid = this.programa.postgrado?.area?.id;
      const asesor_id = this.$store.state.DATA_USER.id;
      const asesor_name = `${u.nombres} ${u.pri_apellido} ${u.seg_apellido}`.trim()
      const programa = this.programa.nombre_compuesto.replaceAll('|',' ');
      const area_id = areaid? areaid : 15; // por defecto, ya que viene del posgrado y eso se esta harcodeando para la oferta de programa universidad

      const raw = [asesor_id, asesor_name, programa, area_id].join('|')
      const token = btoa(String.fromCharCode(...new TextEncoder().encode(raw))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')

      const tok_data_asesor = this.generarOnlytoken()
      const raw2 = ['-', tok_data_asesor,'-', area_id].join('|')
      const token2 = btoa(String.fromCharCode(...new TextEncoder().encode(raw2))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')

      const unidad = this.$store.state.CARGO.sede.unidad_negocio;
      const mapa = {
        1: 'https://formulario.esam.edu.bo/',
        5: 'https://formulario.esamlatam.com/',
        14: 'https://formulario.ispi.edu.pa/',
        15: 'https://formulario.upi.edu.pa/',
        10: 'https://formulario.dbussinesschool.com/',
      } 

      let link = mapa[unidad] + `?t=${token}`
      let link2 = mapa[unidad] + `?reg=${token2}`

      if(!link) link = mapa[1] + `?t=${token}`
      if(!link2) link2 = mapa[1] + `?reg=${token2}`

      let apidev = process.env.VUE_APP_GRAPHQL;
      if( apidev.includes("apidev") ){
        link = link.replaceAll('formulario.','formulariotest.')
        link2 = link2.replaceAll('formulario.','formulariotest.')
      } 

      // this.enlace = link;  
      this.enlace = link2;  
      this.enlace_corto = link2;
    },

    generartoken() {        
      let a1 = 'A';
      let a2 = 'B';
      let a3 = 'C';
      let a4 = 'D';
      let a5 = 'E';
      let a6 = 'F';
      let a7 = 'G';
      let a8 = 'H';
      let a9 = 'I';
      let a0 = 'J';
      let iduser = this.$store.state.DATA_USER.id;
      let tok = this.programa.id + '-' + iduser;
      tok = tok.replace(/1/g, a1);
      tok = tok.replace(/2/g, a2);
      tok = tok.replace(/3/g, a3);
      tok = tok.replace(/4/g, a4);
      tok = tok.replace(/5/g, a5);
      tok = tok.replace(/6/g, a6);
      tok = tok.replace(/7/g, a7);
      tok = tok.replace(/8/g, a8);
      tok = tok.replace(/9/g, a9);
      tok = tok.replace(/0/g, a0);
      //this.enlace = process.env.VUE_APP_DOMAIN + 'registro?t=' + tok;
      this.enlace = this.unidad.sitio_web + '/registro?t=' + tok;
      this.enlace = this.enlace.replaceAll('//r','/r');
      if(this.unidad.id == 3) this.enlace += `&site=ciberkids`
      // window.console.log('>>>',this.unidad);

      if(this.programa.universidad && this.programa.universidad.nombre=='Universidad Politécnica Internacional'){
        this.unidad.id = 15 // upi 
      }

      if(this.unidad.id == 5){
        this.enlace = `https://formulario.esamlatam.com/registro?t=${tok}`
      }
      if(this.unidad.id == 14){
        this.enlace = `https://formulario.ispi.edu.pa?t=${tok}`
      }

      if(this.unidad.id == 15){ // upi 
        const codereg = `${this.programa.id}-${iduser}-p`
        const code = this.codificarBase64(codereg) 
        this.enlace = `https://formulario.upi.edu.pa/${code}/registro.html` 
        this.enlace2 = `https://formulario.upi.edu.pa/${code}/registro.html?filterins=0` 
      }

      return tok;
    },

    generarOnlytoken() {        
      let a1 = 'A';
      let a2 = 'B';
      let a3 = 'C';
      let a4 = 'D';
      let a5 = 'E';
      let a6 = 'F';
      let a7 = 'G';
      let a8 = 'H';
      let a9 = 'I';
      let a0 = 'J';
      let iduser = this.$store.state.DATA_USER.id;
      let tok = this.programa.id + '-' + iduser;
      tok = tok.replace(/1/g, a1);
      tok = tok.replace(/2/g, a2);
      tok = tok.replace(/3/g, a3);
      tok = tok.replace(/4/g, a4);
      tok = tok.replace(/5/g, a5);
      tok = tok.replace(/6/g, a6);
      tok = tok.replace(/7/g, a7);
      tok = tok.replace(/8/g, a8);
      tok = tok.replace(/9/g, a9);
      tok = tok.replace(/0/g, a0);
      return tok;
    },
  },
};
</script>

<style scoped>
.ge-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #7986cb;
  display: block;
}
.ge-value {
  font-size: 0.83rem;
  color: #283593;
  font-weight: 500;
  margin-bottom: 4px;
}
.ge-link-box {
  background: #f0f4ff;
  border: 1px solid #c5cae9;
  border-radius: 6px;
  padding: 8px 12px;
}
.ge-link-input {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 0.85rem;
  color: #1a237e;
  font-family: monospace;
  outline: none;
  resize: none;
}
#aquivaelqr > img { width: 100px !important; }
</style>
